var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { SelectCheckboxOption, SelectOption, } from './SelectOption/SelectOption';
import './DropdownOptions.styles.scss';
var DropdownOptions = React.forwardRef(function (_a, optionsRef) {
    var filteredSelectOptions = _a.filteredSelectOptions, isMultipleSelect = _a.isMultipleSelect, multiSelectedOptions = _a.multiSelectedOptions, onMouseOver = _a.onMouseOver, onSelectOption = _a.onSelectOption, searchTerm = _a.searchTerm, selectedOption = _a.selectedOption;
    var isOptionSelected = function (option) {
        if (isMultipleSelect) {
            return (!!multiSelectedOptions &&
                multiSelectedOptions
                    .map(function (opt) { return opt.value.toString(); })
                    .includes(option.value.toString()));
        }
        else {
            return !!selectedOption && selectedOption.value === option.value;
        }
    };
    var getLiClassName = function (option) {
        var liClassList = [];
        if (isMultipleSelect) {
            liClassList.push('li-checkbox');
        }
        if (isOptionSelected(option)) {
            liClassList.push('selected-option');
        }
        return liClassList.join(' ');
    };
    return (_jsx("ul", __assign({ className: "hefesto-select-dropdown-options", ref: optionsRef, onMouseOver: onMouseOver, "data-testid": "hefesto-select-dropdown" }, { children: filteredSelectOptions.map(function (option, idx) { return (_jsxs("li", __assign({ "data-testid": "hefesto-select-option", value: option.value, className: getLiClassName(option), onClick: function (e) {
                e.stopPropagation();
                onSelectOption(option.value);
            } }, { children: [isMultipleSelect && (_jsx(SelectCheckboxOption, { label: option.label, value: option.value, checked: isOptionSelected(option), descriptions: option.descriptions, searchTerm: searchTerm })), !isMultipleSelect && (_jsx(SelectOption, { label: option.label, value: option.value, descriptions: option.descriptions, searchTerm: searchTerm }))] }), idx)); }) })));
});
DropdownOptions.displayName = 'dropdownoptions';
export default DropdownOptions;
